import React from "react";
import Typography from "@material-ui/core/Typography";
import * as theme from "../theme";
import { keyframes, css } from 'styled-components';
import styled from "styled-components";

export function TwoHeading(props) {
  const heading1 = props.heading1;
  const heading2 = props.heading2;
  const heading3 = props.heading3;
  const subheading1 = props.subheading1;
  const handleSubHeadingClick = props.handleSubHeadingClick;
  const warningheader = props.warningheader || '';
  const fontSize = props.fontSize ? props.fontSize : "5vmin";
  //import { styled } from '@mui/material/styles';
  const warningDisplay = warningheader == '' ? "none" : "block"
  
  const blink = keyframes `
    from { opacity: 0; }
    to { opacity: 1; }
  `;
  const BlinkedBox = styled('div')({
    animation: css`${blink} 1s linear infinite`,
    animationDuration: '1s',
    animationIterationCount: '3'
  });

  return (
    <div>
      <div
        style={{whitespace:"nowarp"}}
      >
      <Typography
        variant="h5"
        component="h5"
        style={{
          fontFamily: "GibsonSemiBd",
          fontSize: fontSize,
          color: theme.COLORS.primary_navyblue,
          display:"inline-block"
        }}
      >
        {heading1}
      </Typography>
      <Typography
          style={{
            fontFamily: "GibsonSemiBd",
            color: theme.COLORS.primary_navyblue,
            display:"inline-block",
            marginLeft:"1%",
            cursor: handleSubHeadingClick ? 'pointer' : null
          }}
          onClick={handleSubHeadingClick}
        >
          {subheading1 }
        </Typography>
        <div style={{float:"right", width:"35%", display: warningDisplay}}>
          <BlinkedBox>
            <Typography
            style={{
              fontFamily: "GibsonSemiBd",
              color: theme.COLORS.primary_navyblue,
              display:"inline-block",
              marginLeft:"1%",
              fontSize:"small"
            }}
            >
            {warningheader}
            </Typography> 
         </BlinkedBox> 
        </div>
        </div>
      <Typography
        style={{
          fontSize: 15,
          fontFamily: "GibsonRegular",
          color: "gray",
        }}
        color="textSecondary"
      >
        {heading2}
      </Typography>
      <Typography
        style={{
          fontSize: 25,
          fontFamily: "GibsonSemiBd",
          color: "white",
        }}
        color="textSecondary"
      >
        {heading3}
      </Typography>
    </div>
  );
}
